<template>
    <div class="list_box">
        <div class="news_box hvr-underline-from-center" v-for="(item, index) in list" :key="index" @click="showNewsDetail( item )">
            <div class="left">
                <img :src="item.headpic" v-if="item.headpic && item.headpic.indexOf('http') != -1" alt="">
                <img :src="$ImgUrl + item.headpic" v-if="item.headpic && item.headpic.indexOf('http') == -1" alt="">
                <img src="../../assets/static/index/left_nav_bg3.png" v-if="!item.headpic" alt="">
            </div>
            <div class="right">
                <div class="title">
                     {{ item.newsTitle }} 
                </div>
                <div class="time">
                    <span class="iconfont icon-shijian"></span>{{ item.createTime }}
                </div>
                <div class="content">
                    <span>{{ item.newsContent }}</span>
                </div>
                <div class="more">
                    查看详情 >
                </div>
            </div>
        </div>

        <!-- 分页 -->
        <div class="page" style="text-align:center;">
            <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pageNum"
            :pageSize="10"
            @current-change="pageChange"
            :total="10 * totalPage">
            </el-pagination>
        </div>


    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                pageNum: 1,
                totalPage: 1,
            }
        },
        computed: {
            specialReportId() {
                return Number( this.$route.params.id )
            },
            ...mapGetters(['token'])
        },
        props: {
            list:Array
        },
        mounted() {
           console.log( this.list ) 
        },
        methods: {
            // 页码变化
            pageChange ( page ) {
                this.pageNum = page 
                this.$emit("update", this.pageNum)
            },
            // 查看新闻详情
            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.newsId}`,
                    query: {
                        specialReportId: this.specialReportId
                    }
                })
            }
            
        },
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
            background: red !important;
        }
        .hvr-underline-from-center::before {
            background: #2767c4 ;
        }
</style>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.list_box {
    width: 1200px;
    box-sizing: border-box;
    margin: 20px auto;
    .news_box {
        display: flex;
        align-items: center;
        margin: 40px 0;
        cursor: pointer;
        padding: 20px 0;
        .left {
            width: 263px;
            height: 158px;
            img {
                width: 263px;
                height: 158px;
            }
        }
        .right {
            margin-left: 20px;
            .title {
                font-size: 18px;
                font-weight: bold;
            }
            .time {
                font-size: 14px;
                color: #C8C8C8;
                margin: 20px 0;
            }
            .content {
                font-size: 16px;
                color: #828181;
                height: 54px;
                span {
                    @include MultipleRows(2);
                }
            }
            .more {
                font-size: 14px;
                color: #818181;
            }
        }
    }
}
</style>